import React from "react";
import { TextField } from "@mui/material";
import {
  LocalizationProvider,
  DatePicker as MUIDatePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const DatePicker = ({ name, label, value, onChange, minDate, maxDate, shouldDisableDate, defaultValue, height, fontSize, fullWidth, size, width, disabled, format }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MUIDatePicker
        name={name}
        label={label}
        value={value}
        views={['year', 'month', 'day']}
        defaultValue={defaultValue}
        format={format}
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
        onChange={(newValue) => onChange(newValue)}
        renderInput={(params) => <TextField {...params} fullWidth />}
        shouldDisableDate={shouldDisableDate}
        slotProps={{
          textField: {
            fullWidth,
            size,
            sx: {
              width,
              "& .MuiInputBase-root": {
                height,
                fontSize,
              },
              "& .MuiInputLabel-root": {
                fontSize,
              },
              "& .MuiOutlinedInput-input": {
                padding: "8px 12px",
              },
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default DatePicker;